/* eslint-disable no-dupe-else-if */
/* eslint-disable no-unsafe-optional-chaining */
import React, { useCallback, useEffect, useRef, useState } from "react";
import MainFooterComponent from "common/components/MainFooterComponent/MainFooterComponent";
import HeaderFilterCourses from "common/components/HeaderFilterCourses";
import PracticeByCoursesTab from "features/bidding/components/PracticeByCoursesTab/PracticeByCoursesTab";

import "./ByHandExercise.scss";

// import images
import DeffenceScreenHeartCard from "assets/images/DeffenceScreenHeartCard.png";
import { useTypedDispatch, useTypedSelector } from "store";
import { getAllBiddingCourses } from "store/game/thunkActions";
import { setGame } from "store/game/slice";
import { getExerciseByCource, getExerciseByCourceInteractiveBid } from "store/users/thunkActions";
import { useNavigate, useSearchParams } from "react-router-dom";
import { setSimpleField, setTriggerAlert } from "store/users/slice";
import GameHeader from "common/components/GameHeader/GameHeader";
import { useQuery } from "hooks/useQuery";
import MainPageHeaderMobile from "common/components/MainPageHeader/MainPageHeaderMobile";
import TabsCourses from "features/game/components/TabsCourses";
import { showMobile } from "helpers/adaptation";
import { basicPrepareRouteToGame } from "common/helpers/routeToGame";
import { BiddingEnum } from "enums/enums";
import { ICourseValue } from "types/common";
import { GameType } from "types/game";

function ByHandExercise() {
  const dispatch = useTypedDispatch();
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [keyTab, setKeyTab] = useState("10");
  const [searchRes, setSearchRes] = useState<any[]>([]);
  const params = useQuery();
  const [dataAllCourses, setDataAllCourses] = useState<any>({});
  const takeLevles = useRef(false);
  const [expireModal, setExpireModal] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();

  const level = useTypedSelector((store) => store.game.levels);

  useEffect(() => {
    if (searchParams.get("type")) {
      setKeyTab(searchParams.get("type")!);
    }
  }, [searchParams]);

  useEffect(() => {
    if (params?.get("type")) {
      setKeyTab(params?.get("type") as string);
    }
  }, [params]);

  useEffect(() => {
    const getData = async () => {
      try {
        const res: any = await dispatch(getAllBiddingCourses());

        const boofer: any = {};

        if (res?.Results?.length > 0) {
          res?.Results?.forEach((val: any) => {
            boofer[val?.parent?.parentCode] = val?.parent?.columns;
          });
        }

        boofer[60] = res?.Results;
        boofer[70] = [];

        setDataAllCourses(boofer);
      } catch {
        //
      }
    };
    getData();
  }, [dispatch]);

  const onPressItem = useCallback(
    async (
      val: ICourseValue,
      type: BiddingEnum.BIDDING | BiddingEnum.INTERACTIVE_BIDDING,
      isBidPlay: boolean
    ) => {
      if (val.isEnabled !== true && val.isEnabled !== undefined) {
        return;
      }
      try {
        dispatch(setSimpleField({ type: "isLoading", value: true }));

        let res: any;
        if (type === BiddingEnum.BIDDING) {
          res = await dispatch(getExerciseByCource(val?.Id, level));
        } else if (type === BiddingEnum.INTERACTIVE_BIDDING) {
          res = await dispatch(getExerciseByCourceInteractiveBid(val?.Id, level));
        }
        const { arrResult } = basicPrepareRouteToGame(
          type === BiddingEnum.BIDDING ? type : (BiddingEnum.INTERACTIVE_BIDDING as GameType),
          res,
          dispatch
        );

        if (arrResult?.length > 0) {
          const data = {
            gameId: arrResult[0]?.Data?.Id || arrResult[0]?.Data?.Id_Bid,
            courseId: val?.Id || 3,
            gameName: arrResult[0]?.Data?.Name,
            gameTitle: val?.Name,
            SEODescription: val?.SEODescription,
            type
          };
          localStorage.setItem(BiddingEnum.BIDDING, JSON.stringify(data));
          dispatch(setGame(data));

          if (type === BiddingEnum.BIDDING) {
            navigate("/bidding?type=" + keyTab);
          } else if (type === BiddingEnum.INTERACTIVE_BIDDING && isBidPlay) {
            navigate(`/bidding_interactive?type=${keyTab}&isBidPlay=true`);
          } else if (type === BiddingEnum.INTERACTIVE_BIDDING) {
            navigate("/bidding_interactive?type=" + keyTab);
          }
        } else {
          dispatch(
            setTriggerAlert({
              show: true,
              title: "This course is empty"
            })
          );
        }
      } catch {
        //
      } finally {
        dispatch(setSimpleField({ type: "isLoading", value: false }));
      }
    },
    [dispatch, keyTab, navigate, level]
  );

  const onSearch = useCallback(
    (text: string) => {
      setSearch(text);
      if (text === "") {
        return setSearchRes([]);
      }
      const boofer: any[] = [];
      const searchLower = text.toLowerCase();
      const addedIds = new Set();

      Object.values(dataAllCourses).forEach((topic: any) => {
        topic?.forEach((val: any) => {
          val?.courses?.forEach((item: any) => {
            if (
              item?.Tags?.toLowerCase()?.includes(searchLower) ||
              item?.Name?.toLowerCase()?.includes(searchLower)
            ) {
              if (item.isEnabled !== false) {
                const itemId = item?.Id || item?.CourseId || item?.Name;
                if (!addedIds.has(itemId)) {
                  addedIds.add(itemId);
                  boofer.push(item);
                }
              }
            }
          });
        });
      });
      setSearchRes(boofer);
    },
    [dataAllCourses]
  );

  const onHandleChangeLevel = useCallback(
    (val: any) => {
      const audit: number[] = [];
      if (val?.ease) audit.push(10);
      if (val?.medium) audit.push(20);
      if (val?.hard) audit.push(30);

      const allCoursesUpdated = { ...dataAllCourses };

      Object.keys(allCoursesUpdated).forEach((topicKey) => {
        const topicCourses = allCoursesUpdated[topicKey];
        if (!topicCourses) return;

        allCoursesUpdated[topicKey] = topicCourses.map((group: any) => {
          if (group?.courses?.length) {
            return {
              ...group,
              courses: group.courses.map((item: any) => ({
                ...item,
                isEnabled:
                  audit.length === 0
                    ? true
                    : !!audit.find((level) => `${item?.Levels}`.includes(`${level}`))
              }))
            };
          }
          return group;
        });
      });

      takeLevles.current = true;
      setDataAllCourses(allCoursesUpdated);

      if (search) {
        const filtered: any[] = [];
        const searchLower = search.toLowerCase();
        const addedIds = new Set();
        Object.values(allCoursesUpdated).forEach((topic: any) => {
          topic?.forEach((group: any) => {
            group?.courses?.forEach((item: any) => {
              if (
                item.isEnabled &&
                (item?.Tags?.toLowerCase().includes(searchLower) ||
                  item?.Name?.toLowerCase().includes(searchLower))
              ) {
                const itemId = item?.Id || item?.CourseId || item?.Name;
                if (!addedIds.has(itemId)) {
                  addedIds.add(itemId);
                  filtered.push(item);
                }
              }
            });
          });
        });
        setSearchRes(filtered);
      }
    },
    [dataAllCourses, search]
  );

  useEffect(() => {
    if (Object.keys(dataAllCourses).length > 0 && !takeLevles.current) {
      const resLevels = localStorage.getItem("levels");
      if (resLevels) {
        onHandleChangeLevel(JSON.parse(resLevels));
      } else {
        onHandleChangeLevel({});
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataAllCourses, onHandleChangeLevel]);

  return (
    <>
      <div className="ByHandExercise-screen-wrapper">
        <div>
          {!showMobile && <GameHeader />}
          {showMobile && <MainPageHeaderMobile showGameMenu />}
          <div className="ByHandExercise-statement-wrapper">
            <HeaderFilterCourses
              title="הכרזות"
              type={BiddingEnum.BIDDING}
              onChangeText={onSearch}
              value={search}
              onHandleChangeLevel={onHandleChangeLevel}
              onExpireModal={() => setExpireModal(true)}
            />
            <div
              className={`ByHandExercise-Tabs-main-bidding ${
                keyTab === "10" ? "tabs-wrapper-first-element" : ""
              } ${keyTab === "70" ? "tabs-wrapper-last-element" : ""}`}>
              <div className="tabs-wrapper-first-element"></div>
              <div className={search ? "search-mode-active" : ""}>
                <TabsCourses
                  keyTab={keyTab}
                  isExpired={expireModal}
                  onExpiredClose={() => setExpireModal(false)}
                  onSelect={(k: any) => {
                    setKeyTab(k);
                    setSearch("");
                    setSearchRes([]);
                    setSearchParams(`type=${k}`);

                    const newurl =
                      window.location.protocol +
                      "//" +
                      window.location.host +
                      window.location.pathname +
                      "?type=" +
                      k;
                    window.history.pushState({ path: newurl }, "", newurl);

                    const myDiv: any = document.getElementsByClassName("PracticeByCourses-main");
                    if (myDiv && myDiv.length) {
                      for (let i = 0; i <= myDiv.length; i++) {
                        myDiv[i]?.scrollTo({ top: 0 });
                      }
                    }
                  }}
                  RenderComponent={PracticeByCoursesTab}
                  dataAllCourses={dataAllCourses}
                  searchRes={searchRes}
                  onPressItem={onPressItem}
                  search={search}
                  type={BiddingEnum.BIDDING}
                  listTitle={{
                    10: "תחילת הדרך",
                    20: "מכרז התקפי",
                    30: "מכרז תחרותי",
                    40: "קונבנציות",
                    50: "2 על 1",
                    60: "תרגול משולב",
                    70: "תרגול חבילות"
                  }}
                />
              </div>
              <img className="card-img2" src={DeffenceScreenHeartCard} alt="img" />
            </div>
          </div>
        </div>
        {!showMobile && <MainFooterComponent />}
      </div>
    </>
  );
}

export default ByHandExercise;
